import { render } from "./UserInfoDialog.vue?vue&type=template&id=791381e5"
import script from "./UserInfoDialog.vue?vue&type=script&lang=js"
export * from "./UserInfoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__